import { useRef } from 'react';

const useRootContainer = id => {
  const ref = useRef(document.getElementById(id));

  function getRootElem() {
    if (!ref.current) {
      ref.current = document.createElement('div');
      ref.current.id = id;
      document.body.appendChild(ref.current);
    }

    return ref.current;
  }

  return getRootElem();
};

export { useRootContainer };
